// Public, unauthenticated view for a single-day share link -- same shape as
// SharedWeekPlanPage.jsx, just scoped to one day and with no
// snack/preserves/medicinal section (those lists are week-scoped, not
// day-scoped, so a day link never carries them -- see
// 0018_week_plan_sharing_schema.sql's comment on week_plan_shares).
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { COLORS, FONT_SIZE, SPACE, RADIUS } from "../lib/constants";
import { getWeekPlanDayByShareToken } from "../lib/db";
import { WeekPlanDayPreview } from "../components/WeekPlanPreview";

export function SharedWeekPlanDayPage() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, day: null, error: false });
  const { paper, card, ink, soft, line } = COLORS;

  useEffect(() => {
    let cancelled = false;
    getWeekPlanDayByShareToken(token)
      .then((day) => {
        if (!cancelled) setState({ loading: false, day, error: false });
      })
      .catch(() => {
        if (!cancelled) setState({ loading: false, day: null, error: true });
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  const wrapperStyle = { background: paper, color: ink, fontFamily: "var(--font-serif)", minHeight: "100vh", padding: SPACE.x4, boxSizing: "border-box" };

  if (state.loading) {
    return (
      <div style={{ ...wrapperStyle, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span style={{ color: soft }}>Loading day…</span>
      </div>
    );
  }

  if (state.error || !state.day) {
    return (
      <div style={{ ...wrapperStyle, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span style={{ color: soft }}>This link isn't valid — it may have been revoked.</span>
      </div>
    );
  }

  return (
    <div style={wrapperStyle}>
      <div style={{ maxWidth: 700, margin: "0 auto", background: card, border: `1px solid ${line}`, borderRadius: RADIUS.xxl, padding: SPACE.x4 }}>
        <div className="mp-sans" style={{ fontSize: FONT_SIZE.xs, color: soft, marginBottom: SPACE.lg }}>
          Shared from The Weekly Kitchen
        </div>
        <WeekPlanDayPreview day={state.day} colors={COLORS} />
      </div>
    </div>
  );
}
